import * as api from '../api.js';

export const getPlans = async (set, get) => {
  const country = get().location?.country ?? 'US';
  const response = await api.getPlans({ country });
  if (!response || response.failure) {
    return;
  }
  set({ plans: response.success?.plans || [] }, false, { type: 'getPlans' });
};
